import { MultiValueProps, OptionProps, components } from 'react-select';

import styles from './AudioSelectComponents.module.css';
import cn from 'classnames';
import TiktokAudioBadge, {
    TiktokAudioBadgeInfo,
} from '../../../../../TikTok/audios/components/TiktokAudioBadge/TiktokAudioBadge';

export type AudioOption = { value: number } & TiktokAudioBadgeInfo;

type AudioSelectOptionProps = OptionProps<AudioOption, true>;

export const AudioSelectOption = (props: AudioSelectOptionProps) => {
    const optionData = props.data as AudioOption;
    return (
        <components.Option {...props}>
            <div className={styles.container}>
                <TiktokAudioBadge
                    audio={{
                        tiktokId: optionData.tiktokId,
                        title: optionData.title,
                        authorName: optionData.authorName,
                        isOriginal: optionData.isOriginal,
                        imageUrl: optionData.imageUrl,
                        audioPlayUrl: optionData.audioPlayUrl,
                    }}
                />
            </div>
        </components.Option>
    );
};

type SelectedAudioSelectOptionProps = MultiValueProps<AudioOption>;

export const AudioSelectOptionSelectedValue = (props: SelectedAudioSelectOptionProps) => {
    const optionData = props.data;
    return (
        <components.MultiValue {...props}>
            <div className={styles.infoContainer}>
                <span className={cn(styles.title, styles.small)}>{optionData.title}</span>
                <span>{optionData.authorName}</span>
            </div>
        </components.MultiValue>
    );
};
